module.exports = __webpack_public_path__ + "static/media/tt.4705d420.svg";